export const ABSENCE_CREATE_EDIT = "ABSENCE_CREATE_EDIT";
export const ABSENCE_CREATE_EDIT_SUCCESS = "ABSENCE_CREATE_EDIT_SUCCESS";
export const ABSENCE_CREATE_EDIT_ERROR = "ABSENCE_CREATE_EDIT_ERROR";
export const ABSENCE_DETAILS = "ABSENCE_DETAILS";
export const ABSENCE_DETAILS_SUCCESS = "ABSENCE_DETAILS_SUCCESS";
export const ABSENCE_DETAILS_ERROR = "ABSENCE_DETAILS_ERROR";
export const ABSENCE_DELETE = "ABSENCE_DELETE";
export const ABSENCE_DELETE_SUCCESS = "ABSENCE_DELETE_SUCCESS";
export const ABSENCE_DELETE_ERROR = "ABSENCE_DELETE_ERROR";
export const ABSENCES_LIST = "ABSENCES_LIST";
export const ABSENCES_LIST_SUCCESS = "ABSENCES_LIST_SUCCESS";
export const ABSENCES_LIST_ERROR = "ABSENCES_LIST_ERROR";